module.exports = __webpack_public_path__ + "static/media/10_showesportes.c84c6922.jpg";